import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ImportContainer} from 'app/Model/dataProcess/importContainer';

export type InspectContext = '' | 'containerDetails' | 'containerCatalog';

@Component({
  selector: 'np-inspect-panel',
  templateUrl: './inspectPanel.component.html',
  styleUrls: ['./inspectPanel.component.css'],
  standalone: false
})
export class InspectPanelComponent implements OnInit {
  @Input() container: ImportContainer | null = null;
  @Input() context?: InspectContext;
  @Input() catalogId: string | null = null;

  @Output() closePanel = new EventEmitter<void>();
  @Output() containerSaved = new EventEmitter<ImportContainer>();

  get containerName(): string {
    return this.container?.name || 'n/b';
  }

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (!this.context) {
      const url = this.router.url;
      this.context = url.includes('container-details') ? 'containerDetails' : '';
    }
  }
}
